import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';
import type { FC } from 'react';
import React from 'react';

interface HeaderProps extends TypographyProps {
  title: string;
}

export const Header: FC<HeaderProps> = ({ title, ...props }) => {
  return (
    <Typography variant='h3' {...props}>
      {title}
    </Typography>
  );
};
